export const Constants = {
    api: 'https://apiadmin.herbie.com.br/api',
    apiMautic: 'https://www.herbie.com.br/wp-json/herbie/v1'
};
